import { render, staticRenderFns } from "./FormRegistration.vue?vue&type=template&id=127a36c1&scoped=true&"
import script from "./FormRegistration.vue?vue&type=script&lang=js&"
export * from "./FormRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FormRegistration.vue?vue&type=style&index=0&id=127a36c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a36c1",
  null
  
)

export default component.exports